import React from 'react';
import classNames from 'classnames';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';

import Emoji, { TEmojiKey } from '../Emoji/Emoji';
import { IAlyceCustomTheme } from '../../styles/alyceTheme';

const useStyles = makeStyles<IAlyceCustomTheme>(({ palette }) => ({
  stepIcon: {
    backgroundColor: palette.common.white,
    color: palette.common.white,
    border: `2px solid ${palette.grey.light}`,
    zIndex: 1,
    width: 32,
    height: 32,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  stepIconActive: {
    border: `2px solid ${palette.customStyling.highlightColor}`,
  },
  stepIconCompleted: {
    border: `2px solid ${palette.customStyling.highlightColor}`,
  },
  emojiBlock: {
    marginRight: 0,
    width: 16,
    height: 16,
  },
}));

export interface IStatusStepIconProps {
  active: boolean;
  completed: boolean;
  emoji: TEmojiKey;
}

const StatusStepIcon = ({ active, completed, emoji }: IStatusStepIconProps): JSX.Element => {
  const classes = useStyles();

  return (
    <Box
      className={classNames(classes.stepIcon, {
        [classes.stepIconActive]: active,
        [classes.stepIconCompleted]: completed,
      })}
    >
      <Emoji width={16} height={16} emoji={emoji} overrideSpanClass={classes.emojiBlock} />
    </Box>
  );
};

export default StatusStepIcon;
